import { render, staticRenderFns } from "./google_food_general_tab.vue?vue&type=template&id=03477e22&scoped=true&"
import script from "./google_food_general_tab.vue?vue&type=script&lang=js&"
export * from "./google_food_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03477e22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03477e22')) {
      api.createRecord('03477e22', component.options)
    } else {
      api.reload('03477e22', component.options)
    }
    module.hot.accept("./google_food_general_tab.vue?vue&type=template&id=03477e22&scoped=true&", function () {
      api.rerender('03477e22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/google_food/location/tabs/google_food_general_tab.vue"
export default component.exports